import React from 'react';
import Icon, { IconProps } from './Icon';

// pause-circle *
const PauseCircleOutlinedSvg: React.FC<React.SVGProps<SVGSVGElement>> = (
    props
) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M9.5 15V9M14.5 15V9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
const PauseCircleOutlined: React.FC<Omit<IconProps, 'component'>> = (props) => (
    <Icon
        component={PauseCircleOutlinedSvg}
        className="s9sicon-pause-circle"
        {...props}
    />
);
export default PauseCircleOutlined;
